const defaultMarkerColor = '#6b6bff'
const blue = '#0d6efd'
const white = '#ffffff'
const orange = 'orange'
const toolgrey = '#5b5b5b'
const bglightblue = '#f2f6fa'
const pathomiqblue = '#101a46'
const pathomiqred = '#b61717'
const muiblue = '#1976d2'
const bgGrey = '#E2E8F0'
const lightGrey = '#f5f5f5'
const msgBoxColor = '#d3e4f5'

export { 
    defaultMarkerColor,
    blue,
    white,
    orange,
    toolgrey,
    bglightblue,
    pathomiqblue,
    pathomiqred,
    muiblue,
    bgGrey,
    lightGrey,
    msgBoxColor
}